module.exports = __webpack_public_path__ + "4d4a631271de21b4eba2caab3832b2c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/huaban_active.png
// module id = 318
// module chunks = 3